import {Trans, useTranslation} from '@/translations/i18n'
import {AccessDashboardCard} from '../access-dashboard-card/AccessDashboardCard'
import {useGetAccessesDashboard} from '../../queries/useGetAccessesDashboard'
import {useParsedSearchParams} from '@/hooks/useParsedSearchParams'
import {filtersParamToPayload} from '@/utilities/helpers'
import {AccessesTableDashboardEmptyState} from '../accesses-table-dashboard/AcccessesTableDashboardEmptyState'
import {AlertCircleIcon, CheckCircleIcon} from '@/components/ui/icon/Icon'
import {useTheme} from 'styled-components'
import {Tooltip} from '@/components/ui/tooltip/Tooltip'
import {Text} from '@/components/ui/text/Text'
import {AccessesSearchParams} from '../../types'

export const AccessesDashboardAbsencesCard = () => {
    const {t} = useTranslation()
    const {searchParams} = useParsedSearchParams(AccessesSearchParams)

    const {data, isLoading} = useGetAccessesDashboard<'absences'>({
        payload: {
            filters: filtersParamToPayload(searchParams.filters)?.filters
        },
        params: {
            card: 'absences',
            startDate: searchParams.startDate,
            endDate: searchParams.endDate
        }
    })

    const {palette} = useTheme()

    if (isLoading || !data) {
        return (
            <AccessesTableDashboardEmptyState title={t('accesses:dashboard_relevant_absences')} isLoading={isLoading} />
        )
    }

    return (
        <AccessDashboardCard
            title={t('accesses:dashboard_relevant_absences')}
            endSlot={
                data.absences.toValidate ? (
                    <>
                        {data.absences.toValidate > 0 ? (
                            <Tooltip variant="light" content={t('accesses:status_to_validate')}>
                                <AlertCircleIcon size={15} color={palette.danger[500]} />
                            </Tooltip>
                        ) : (
                            <CheckCircleIcon size={15} color={palette.success[500]} />
                        )}
                    </>
                ) : null
            }
        >
            <Text size="textSm" palette="neutral" shade="600">
                <Trans
                    i18nKey="accesses:dashboard_relevant_absences_subtitle"
                    values={{count: data?.absences?.detected, total: data?.absences?.treatments}}
                    components={[
                        <Text render="span" size="textLg" palette="neutral" shade="950" weight="600" />,
                        <Text render="span" size="textLg" palette="neutral" shade="600" weight="500" />
                    ]}
                />
            </Text>
        </AccessDashboardCard>
    )
}
